module.exports = __webpack_public_path__ + "img/6.55feef4d.jpg";